import cc from 'cryptocompare';

export default cc;
